import axiosInstance from '@/api/axiosInstance'

export const validateImage = () => {
    // Basic validation placeholder
    return true
}

export const uploadImageToGCS = async (fileOrUri: string | File, folder: string = 'uploads'): Promise<string> => {
    try {
        // Convert fileOrUri to File if it's a string (URI)
        let file: File
        if (typeof fileOrUri === 'string') {
            // If it's a URI, fetch it and convert to File
            const response = await fetch(fileOrUri)
            const blob = await response.blob()
            const filename = fileOrUri.split('/').pop() || 'image.jpg'
            file = new File([blob], filename, { type: blob.type || 'image/jpeg' })
        } else {
            file = fileOrUri
        }

        // Create FormData for multipart upload
        const formData = new FormData()
        formData.append('file', file)
        formData.append('folder', folder)

        // Upload through backend endpoint (avoids CORS issues)
        const uploadResponse = await axiosInstance.post('/api/upload-image/', formData, {
                headers: {
                'Content-Type': 'multipart/form-data',
                },
            timeout: 60000, // 60 second timeout for uploads
        })

        const { url } = uploadResponse.data
        return url
    } catch (error: any) {
        console.error('Error uploading to GCS:', error)
        const errorMessage = error?.response?.data?.error || 
                            error?.response?.data?.detail || 
                            error?.message || 
                            'Error al subir la imagen'
        throw new Error(errorMessage)
    }
}

